/* SANGAHZ logo recolor preview.
   Takes an existing product photo, finds the printed logo (the ink that stands out
   from the garment), and repaints it in the chosen logo color. Used when there is
   no real photo of the exact garment color + logo + logo color combination. */
(function () {
  if (window.SZRecolor) return;

  var REGIONS = {
    garment: { rx0: 0.15, rx1: 0.85, ry0: 0.10, ry1: 0.72 },
    hat: { rx0: 0.12, rx1: 0.88, ry0: 0.08, ry1: 0.80, brim: true }
  };
  var MIN_SPAN = 38;
  var spanCache = {};
  var outCache = {};

  function fileName(u) { return String(u || '').split('/files/').pop().split('?')[0]; }

  function load(name) {
    return new Promise(function (resolve, reject) {
      var im = new Image();
      im.onload = function () { resolve(im); };
      im.onerror = reject;
      im.src = '/cdn/shop/files/' + name + '?width=900';
    });
  }

  /* Caps: the brim can be as dark as the printed logo, so it is treated as
     background. Per column, the brim is the run of brim-colored pixels rising
     from the bottom edge; a smooth curve fitted through those tops (ignoring
     spikes where the run climbs into touching letters) is the seam. */
  function maskBrim(p, bg, W, H, x0, x1, y0, y1) {
    var gw = x1 - x0, gh = y1 - y0;
    function med(xa, xb, ya, yb) {
      var r = [], g = [], b = [];
      for (var Y = ya | 0; Y < yb; Y += 2) for (var X = xa | 0; X < xb; X += 2) {
        var i = Y * W + X; if (bg[i]) continue;
        r.push(p[i * 4]); g.push(p[i * 4 + 1]); b.push(p[i * 4 + 2]);
      }
      if (r.length < 20) return null;
      var m = function (a) { a.sort(function (q, w) { return q - w; }); return a[(a.length / 2) | 0]; };
      return [m(r), m(g), m(b)];
    }
    function dist(i, c) { var dr = p[i * 4] - c[0], dg = p[i * 4 + 1] - c[1], db = p[i * 4 + 2] - c[2]; return Math.sqrt(dr * dr + dg * dg + db * db); }
    var brim = med(x0 + gw * 0.25, x0 + gw * 0.55, y0 + gh * 0.82, y0 + gh * 0.92);
    var crown = med(x0 + gw * 0.62, x0 + gw * 0.82, y0 + gh * 0.18, y0 + gh * 0.32);
    if (!brim || !crown) return;
    var cd = Math.sqrt(Math.pow(brim[0] - crown[0], 2) + Math.pow(brim[1] - crown[1], 2) + Math.pow(brim[2] - crown[2], 2));
    if (cd < 40) return; // brim matches the crown: nothing to separate
    var xs = [], ys = [], X, Y, i;
    for (X = x0; X <= x1; X++) {
      var yb = -1;
      for (Y = y1; Y >= y0; Y--) { if (!bg[Y * W + X]) { yb = Y; break; } }
      if (yb < 0) continue;
      // Skip the soft edge at the bottom, then climb while the pixels stay
      // brim-colored (short gaps allowed for texture such as denim or suede).
      var top = -1, run = 0, miss = 0;
      for (Y = yb; Y >= y0; Y--) {
        i = Y * W + X;
        if (bg[i]) break;
        if (dist(i, brim) <= 70) { top = Y; run++; miss = 0; }
        else if (top < 0) { if (yb - Y > 12) break; }
        else if (++miss > 3) break;
      }
      if (run >= 6) { xs.push(X); ys.push(top); }
    }
    if (xs.length < gw * 0.15) return;
    var keep = xs.map(function () { return true; }), co = null;
    for (var pass = 0; pass < 4; pass++) {
      var S = [[0, 0, 0], [0, 0, 0], [0, 0, 0]], T = [0, 0, 0];
      for (var k = 0; k < xs.length; k++) {
        if (!keep[k]) continue;
        var u = (xs[k] - x0) / gw, v = [1, u, u * u];
        for (var a = 0; a < 3; a++) { T[a] += v[a] * ys[k]; for (var b = 0; b < 3; b++) S[a][b] += v[a] * v[b]; }
      }
      co = solve3(S, T);
      if (!co) return;
      for (k = 0; k < xs.length; k++) {
        var uu = (xs[k] - x0) / gw, f = co[0] + co[1] * uu + co[2] * uu * uu;
        keep[k] = ys[k] >= f - 4; // drop runs that climbed into letters
      }
    }
    var xa = xs[0], xb = xs[xs.length - 1], seamAt = new Int32Array(W).fill(-1);
    for (X = xa; X <= xb; X++) {
      var uX = (X - x0) / gw, seam = Math.round(co[0] + co[1] * uX + co[2] * uX * uX) - 6;
      seamAt[X] = seam;
      for (Y = Math.max(y0, seam); Y <= y1; Y++) bg[Y * W + X] = 1;
    }
    // The curve can sit a little low near the brim tip; grow the brim mask
    // through connected brim-colored pixels, but at most 25px above the curve
    // so letters printed close to the seam are never swallowed.
    var stack = [];
    for (X = xa; X <= xb; X++) if (seamAt[X] > y0) stack.push(seamAt[X] * W + X);
    while (stack.length) {
      var j = stack.pop();
      var nb = [j - 1, j + 1, j - W];
      for (var n = 0; n < 3; n++) {
        var q2 = nb[n], qx = q2 % W, qy = (q2 / W) | 0;
        if (q2 < 0 || qx < xa || qx > xb || bg[q2]) continue;
        if (qy < seamAt[qx] - 25 || dist(q2, brim) > 60) continue;
        bg[q2] = 1; stack.push(q2);
      }
    }
  }

  function solve3(A, B) {
    var m = [A[0].concat(B[0]), A[1].concat(B[1]), A[2].concat(B[2])];
    for (var c = 0; c < 3; c++) {
      var piv = c;
      for (var r = c + 1; r < 3; r++) if (Math.abs(m[r][c]) > Math.abs(m[piv][c])) piv = r;
      if (Math.abs(m[piv][c]) < 1e-9) return null;
      var t = m[c]; m[c] = m[piv]; m[piv] = t;
      for (r = 0; r < 3; r++) if (r !== c) {
        var fct = m[r][c] / m[c][c];
        for (var k = c; k < 4; k++) m[r][k] -= fct * m[c][k];
      }
    }
    return [m[0][3] / m[0][0], m[1][3] / m[1][1], m[2][3] / m[2][2]];
  }

  function analyze(im, region) {
    var W = im.naturalWidth, H = im.naturalHeight;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(im, 0, 0);
    var d = ctx.getImageData(0, 0, W, H), p = d.data, N = W * H;
    var lum = new Float32Array(N), bg = new Uint8Array(N), seen = new Uint8Array(N);
    for (var i = 0; i < N; i++) lum[i] = 0.299 * p[i * 4] + 0.587 * p[i * 4 + 1] + 0.114 * p[i * 4 + 2];
    function isBg(i) {
      var r = p[i * 4], g = p[i * 4 + 1], b = p[i * 4 + 2], a = p[i * 4 + 3];
      if (a < 20) return true;
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
      return mn > 228 && mx - mn < 18;
    }
    // Background = near-white/transparent pixels connected to the image border.
    var stack = [], X, Y;
    for (X = 0; X < W; X++) { stack.push(X, (H - 1) * W + X); }
    for (Y = 0; Y < H; Y++) { stack.push(Y * W, Y * W + W - 1); }
    while (stack.length) {
      var k = stack.pop();
      if (seen[k]) continue;
      seen[k] = 1;
      if (!isBg(k)) continue;
      bg[k] = 1;
      X = k % W; Y = (k / W) | 0;
      if (X > 0) stack.push(k - 1);
      if (X < W - 1) stack.push(k + 1);
      if (Y > 0) stack.push(k - W);
      if (Y < H - 1) stack.push(k + W);
    }
    var x0 = W, x1 = 0, y0 = H, y1 = 0;
    for (i = 0; i < N; i++) if (!bg[i]) {
      X = i % W; Y = (i / W) | 0;
      if (X < x0) x0 = X; if (X > x1) x1 = X; if (Y < y0) y0 = Y; if (Y > y1) y1 = Y;
    }
    var gw = x1 - x0, gh = y1 - y0;
    if (region.brim) maskBrim(p, bg, W, H, x0, x1, y0, y1);
    var R = {
      x0: (x0 + gw * region.rx0) | 0, x1: (x0 + gw * region.rx1) | 0,
      y0: (y0 + gh * region.ry0) | 0, y1: (y0 + gh * region.ry1) | 0
    };
    var vals = [];
    for (Y = R.y0; Y < R.y1; Y += 2) for (X = R.x0; X < R.x1; X += 2) { i = Y * W + X; if (!bg[i]) vals.push(lum[i]); }
    if (vals.length < 50) return null;
    vals.sort(function (a, b) { return a - b; });
    var base = vals[(vals.length / 2) | 0];
    var lo = vals[(vals.length * 0.03) | 0], hi = vals[(vals.length * 0.97) | 0];
    var ink = (base - lo) > (hi - base) ? lo : hi;
    return { canvas: c, ctx: ctx, img: d, lum: lum, bg: bg, W: W, H: H, R: R, gw: gw, gy0: y0, gh: gh, base: base, ink: ink, span: Math.abs(ink - base) };
  }

  function inkT(a, i) { return (a.lum[i] - a.base) / (a.ink - a.base); }

  // Bounding box of the printed logo (robust to stray pixels).
  function logoBox(a) {
    var xs = [], ys = [], R = a.R, W = a.W;
    for (var Y = R.y0; Y < R.y1; Y++) for (var X = R.x0; X < R.x1; X++) {
      var i = Y * W + X;
      if (!a.bg[i] && inkT(a, i) >= 0.6) { xs.push(X); ys.push(Y); }
    }
    if (xs.length < 40) return null;
    xs.sort(function (p, q) { return p - q; }); ys.sort(function (p, q) { return p - q; });
    var lo = (xs.length * 0.005) | 0, hi = (xs.length * 0.995) | 0;
    var b = { x0: xs[lo], x1: xs[hi], y0: ys[lo], y1: ys[hi] };
    b.w = b.x1 - b.x0 + 1; b.h = b.y1 - b.y0 + 1;
    return b;
  }

  function boxBlur(a, w, h, r) {
    var t = new Float32Array(a.length), o = new Float32Array(a.length), x, y, s, n = 2 * r + 1;
    for (y = 0; y < h; y++) {
      s = 0; for (x = -r; x <= r; x++) s += a[y * w + Math.min(w - 1, Math.max(0, x))];
      for (x = 0; x < w; x++) { t[y * w + x] = s / n; s += a[y * w + Math.min(w - 1, x + r + 1)] - a[y * w + Math.max(0, x - r)]; }
    }
    for (x = 0; x < w; x++) {
      s = 0; for (y = -r; y <= r; y++) s += t[Math.min(h - 1, Math.max(0, y)) * w + x];
      for (y = 0; y < h; y++) { o[y * w + x] = s / n; s += t[Math.min(h - 1, y + r + 1) * w + x] - t[Math.max(0, y - r) * w + x]; }
    }
    return o;
  }

  /* Rebuild the bare fabric under a printed area: the smooth shading comes
     from the clean fabric around it (blurred), and the fine texture (acid
     wash, knit) is borrowed from the same row beside the print, never from
     above or below (that is where the hood and the pocket are).
     Returns fill(i) -> [r, g, b] for any pixel inside the box. */
  function fabricFill(A, mask, bx0, bx1, by0, by1) {
    var W = A.W, H = A.H, p = A.img.data, X, Y, i, c;
    var fr = [], fg = [], fb = [];
    for (Y = by0; Y <= by1; Y += 2) for (X = Math.max(0, bx0 - 40); X <= Math.min(W - 1, bx1 + 40); X += 2) {
      i = Y * W + X; if (A.bg[i] || mask[i]) continue;
      fr.push(p[i * 4]); fg.push(p[i * 4 + 1]); fb.push(p[i * 4 + 2]);
    }
    var med = function (a) { a.sort(function (q, w) { return q - w; }); return a.length ? a[(a.length / 2) | 0] : 128; };
    var fab = [med(fr), med(fg), med(fb)];
    var bw = bx1 - bx0 + 1, rx0 = Math.max(0, bx0 - bw), rx1 = Math.min(W - 1, bx1 + bw), ry0 = Math.max(0, by0 - 24), ry1 = Math.min(H - 1, by1 + 24);
    var rw = rx1 - rx0 + 1, rh = ry1 - ry0 + 1, wgt = new Float32Array(rw * rh), ch = [new Float32Array(rw * rh), new Float32Array(rw * rh), new Float32Array(rw * rh)];
    for (Y = 0; Y < rh; Y++) for (X = 0; X < rw; X++) {
      i = (Y + ry0) * W + X + rx0; var ok = !A.bg[i] && !mask[i] ? 1 : 0; wgt[Y * rw + X] = ok;
      for (c = 0; c < 3; c++) ch[c][Y * rw + X] = ok * p[i * 4 + c];
    }
    for (var k = 0; k < 3; k++) { wgt = boxBlur(wgt, rw, rh, 14); for (c = 0; c < 3; c++) ch[c] = boxBlur(ch[c], rw, rh, 14); }
    var low = function (x, y, c) { var j = y * rw + x, ww = wgt[j], v = ww > 1e-6 ? ch[c][j] / ww : fab[c], t = Math.min(1, ww / 0.05); return v * t + fab[c] * (1 - t); };
    var orig = new Uint8ClampedArray(p);
    // Texture offsets: just past the print on either side, in the same row.
    var ds = [bx1 - bx0 + 8, -(bx1 - bx0 + 8), Math.round((bx1 - bx0) * 0.6) + 8, -(Math.round((bx1 - bx0) * 0.6) + 8)];
    return function (i) {
      var X = i % W, Y = (i / W) | 0, lx = X - rx0, ly = Y - ry0, tex = [0, 0, 0], out = [0, 0, 0];
      if (lx < 0 || ly < 0 || lx >= rw || ly >= rh) return [p[i * 4], p[i * 4 + 1], p[i * 4 + 2]];
      for (var d = 0; d < 4; d++) {
        var sx = X + ds[d]; if (sx < rx0 || sx > rx1) continue;
        var j = Y * W + sx; if (A.bg[j] || mask[j]) continue;
        // Skip seams and folds: only borrow from fabric close to the local shade.
        var dev = 0;
        for (var c = 0; c < 3; c++) { tex[c] = orig[j * 4 + c] - low(sx - rx0, ly, c); dev += Math.abs(tex[c]); }
        if (dev > 60) { tex = [0, 0, 0]; continue; }
        break;
      }
      for (c = 0; c < 3; c++) out[c] = Math.max(0, Math.min(255, low(lx, ly, c) + tex[c] * 0.8));
      return out;
    };
  }

  // Ink pixels (and a thin ring around them) inside a box, as a mask.
  function inkMask(a, R, thr, grow) {
    var W = a.W, H = a.H, m = new Uint8Array(W * H), X, Y, i, b = { x0: W, x1: 0, y0: H, y1: 0 };
    for (Y = R.y0; Y < R.y1; Y++) for (X = R.x0; X < R.x1; X++) {
      i = Y * W + X;
      if (a.bg[i] || inkT(a, i) < thr) continue;
      for (var oy = -grow; oy <= grow; oy++) for (var ox = -grow; ox <= grow; ox++) {
        var yy = Y + oy, xx = X + ox;
        if (yy >= 0 && yy < H && xx >= 0 && xx < W) m[yy * W + xx] = 1;
      }
      if (X < b.x0) b.x0 = X; if (X > b.x1) b.x1 = X; if (Y < b.y0) b.y0 = Y; if (Y > b.y1) b.y1 = Y;
    }
    b.x0 = Math.max(0, b.x0 - grow); b.y0 = Math.max(0, b.y0 - grow); b.x1 = Math.min(W - 1, b.x1 + grow); b.y1 = Math.min(H - 1, b.y1 + grow);
    return { m: m, box: b };
  }

  /* Repaint the printed logo in hex. The logo's own soft edge is blended
     against rebuilt fabric (not against the old ink color), so a white
     print turned grey or brown leaves no pale halo. */
  function paint(a, hex, box) {
    var p = a.img.data, W = a.W, R = box || a.R;
    var tr = parseInt(hex.slice(1, 3), 16), tg = parseInt(hex.slice(3, 5), 16), tb = parseInt(hex.slice(5, 7), 16);
    var lb = !box && findLogo(a, 18, 26);
    if (lb) R = { x0: Math.max(0, lb.x0 - 12), x1: Math.min(W, lb.x1 + 13), y0: Math.max(0, lb.y0 - 12), y1: Math.min(a.H, lb.y1 + 13) };
    var im = inkMask(a, R, 0.12, 2), m = im.m, b = im.box;
    if (b.x1 <= b.x0) return null;
    var fill = fabricFill(a, m, b.x0, b.x1, b.y0, b.y1), out = [];
    for (var Y = b.y0; Y <= b.y1; Y++) for (var X = b.x0; X <= b.x1; X++) {
      var i = Y * W + X;
      if (!m[i] || a.bg[i]) continue;
      // al: how much of the new color; kf: how much rebuilt fabric replaces the
      // pixel underneath (plain fabric at the rim stays as it is).
      var t = inkT(a, i), al = Math.max(0, Math.min(1, (t - 0.1) / 0.4)), kf = Math.max(0, Math.min(1, t / 0.3)), f = fill(i), k0 = i * 4;
      var b0 = p[k0] * (1 - kf) + f[0] * kf, b1 = p[k0 + 1] * (1 - kf) + f[1] * kf, b2 = p[k0 + 2] * (1 - kf) + f[2] * kf;
      out.push(i, b0 * (1 - al) + tr * al, b1 * (1 - al) + tg * al, b2 * (1 - al) + tb * al);
    }
    for (var n = 0; n < out.length; n += 4) { var k = out[n] * 4; p[k] = out[n + 1]; p[k + 1] = out[n + 2]; p[k + 2] = out[n + 3]; }
    a.ctx.putImageData(a.img, 0, 0);
    try { return a.canvas.toDataURL('image/webp', 0.9); } catch (e) { return null; }
  }

  async function spanOf(name, regionKey) {
    var key = name + '|' + regionKey;
    if (key in spanCache) return spanCache[key];
    try {
      var a = analyze(await load(name), REGIONS[regionKey]);
      spanCache[key] = a ? a.span : 0;
    } catch (e) { spanCache[key] = 0; }
    return spanCache[key];
  }

  /* candidates: photo URLs of the same garment color + logo (any logo color).
     Returns a data URL of the clearest one with its logo repainted, or null. */
  async function render(candidates, hex, regionKey) {
    regionKey = REGIONS[regionKey] ? regionKey : 'garment';
    var names = [];
    (candidates || []).forEach(function (u) { var n = fileName(u); if (n && names.indexOf(n) < 0) names.push(n); });
    if (!names.length || !/^#[0-9a-fA-F]{6}$/.test(hex)) return null;
    var bestName = null, bestSpan = 0;
    for (var j = 0; j < names.length; j++) {
      var s = await spanOf(names[j], regionKey);
      if (s > bestSpan) { bestSpan = s; bestName = names[j]; }
    }
    if (!bestName || bestSpan < MIN_SPAN) return null;
    var key = bestName + '|' + hex + '|' + regionKey;
    if (outCache[key]) return outCache[key];
    try {
      var a = analyze(await load(bestName), REGIONS[regionKey]);
      if (!a) return null;
      // Caps: only repaint around the logo, so mesh panels and seams keep their color.
      var box = null;
      if (regionKey === 'hat') {
        var lb = findLogo(a, 40, 40);
        if (lb) box = { x0: Math.max(0, lb.x0 - 14), x1: Math.min(a.W, lb.x1 + 15), y0: Math.max(0, lb.y0 - 14), y1: Math.min(a.H, lb.y1 + 15) };
      }
      outCache[key] = paint(a, hex, box);
      return outCache[key];
    } catch (e) { return null; }
  }

  /* Box around the printed logo: the densest band of ink rows (small gaps
     bridged so a tagline under the logo stays with it), then the densest
     band of ink columns inside it. Acid-wash speckle and folds are too
     sparse to win. cx = garment center on the logo's middle row. */
  function findLogo(a, gapX, gapY) {
    var R = a.R, W = a.W, X, Y, i;
    function band(arr, gap) {
      var n = arr.length, sm = new Float32Array(n), mx = 0, at = 0, q;
      for (q = 0; q < n; q++) {
        var s = 0, c = 0;
        for (var d = -3; d <= 3; d++) if (q + d >= 0 && q + d < n) { s += arr[q + d]; c++; }
        sm[q] = s / c; if (sm[q] > mx) { mx = sm[q]; at = q; }
      }
      var lim = mx * 0.12, lo = at, hi = at, miss = 0;
      for (q = at; q >= 0; q--) { if (sm[q] >= lim) { lo = q; miss = 0; } else if (++miss > gap) break; }
      miss = 0;
      for (q = at; q < n; q++) { if (sm[q] >= lim) { hi = q; miss = 0; } else if (++miss > gap) break; }
      return [lo, hi, mx];
    }
    var rows = [];
    for (Y = R.y0; Y < R.y1; Y++) {
      var c = 0;
      for (X = R.x0; X < R.x1; X++) { i = Y * W + X; if (!a.bg[i] && inkT(a, i) >= 0.6) c++; }
      rows.push(c);
    }
    var rb = band(rows, gapY || 26);
    if (rb[2] < 4) return null;
    var y0 = R.y0 + rb[0], y1 = R.y0 + rb[1], cols = [];
    for (X = R.x0; X < R.x1; X++) {
      var c2 = 0;
      for (Y = y0; Y <= y1; Y++) { i = Y * W + X; if (!a.bg[i] && inkT(a, i) >= 0.6) c2++; }
      cols.push(c2);
    }
    var cb = band(cols, gapX || 18);
    var x0 = R.x0 + cb[0], x1 = R.x0 + cb[1];
    var mid = ((y0 + y1) / 2) | 0, gl = -1, gr = -1;
    for (X = 0; X < W; X++) if (!a.bg[mid * W + X]) { if (gl < 0) gl = X; gr = X; }
    return { x0: x0, x1: x1, y0: y0, y1: y1, w: x1 - x0 + 1, h: y1 - y0 + 1, cx: (gl + gr) / 2 };
  }

  var boxCache = {};
  async function logoInfo(name, regionKey) {
    var key = name + '|' + regionKey;
    if (key in boxCache) return boxCache[key];
    try {
      var a = analyze(await load(name), REGIONS[regionKey]);
      var b = a && findLogo(a, regionKey === 'hat' ? 40 : 18, regionKey === 'hat' ? 40 : 26);
      boxCache[key] = b ? { rel: b.w / a.gw } : null;
    } catch (e) { boxCache[key] = null; }
    return boxCache[key];
  }

  /* Put a different logo on a garment photo: erase the logo that is printed
     there, then stamp the wanted logo (lifted from a donor photo) in hex. */
  async function compose(baseName, baseLogoDonor, donorName, hex, regionKey) {
    var region = REGIONS[regionKey];
    var A = analyze(await load(baseName), region);
    var D = analyze(await load(donorName), region);
    if (!A || !D) return null;
    var cap = regionKey === 'hat';
    // Arched cap lettering has wide gaps between letters; bridge them.
    var ob = findLogo(A, cap ? 40 : 18, cap ? 40 : 26), db = findLogo(D, cap ? 40 : 18, cap ? 40 : 26);
    if (!ob || !db) return null;
    // A logo found up in the hood/crown is a misread; let the caller try another photo.
    if ((ob.y0 + ob.y1) / 2 < A.gy0 + A.gh * 0.22) return null;
    // Size: keep the ratio between the two logos as they print. A base photo
    // whose logo has no donor (a custom design) keeps the same width.
    var relNew = await logoInfo(donorName, regionKey);
    var relOld = baseLogoDonor ? await logoInfo(baseLogoDonor, regionKey) : relNew;
    if (!relNew || !relOld) return null;
    var p = A.img.data, W = A.W, H = A.H, i, X, Y, k;

    // 1. Erase the old logo: ink pixels in its box (grown 2px) take the fabric
    //    from the same column just above or below, so folds and acid-wash
    //    texture carry across.
    var pad = cap ? 18 : 10;
    var bx0 = Math.max(0, ob.x0 - pad), bx1 = Math.min(W - 1, ob.x1 + pad);
    var by0 = Math.max(0, ob.y0 - (cap ? 6 : pad)), by1 = Math.min(H - 1, ob.y1 + (cap ? 6 : pad));
    var mask = new Uint8Array(W * H);
    for (Y = by0; Y <= by1; Y++) for (X = bx0; X <= bx1; X++) {
      i = Y * W + X;
      if (!A.bg[i] && inkT(A, i) >= 0.25) {
        for (var oy = -2; oy <= 2; oy++) for (var ox = -2; ox <= 2; ox++) {
          var yy = Y + oy, xx = X + ox;
          if (yy >= 0 && yy < H && xx >= 0 && xx < W) mask[yy * W + xx] = 1;
        }
      }
    }
    if (regionKey === 'hat') {
      // Caps: the crown is smooth, so the whole logo box is repainted row by
      // row, blending the clean fabric just left and right of the box. This
      // also clears faint fills and outlines the ink mask would miss.
      // Fabric color of the crown, so seams, shadows and the brim edge are
      // never used as fill (they would smear a dark wedge across the cap).
      var cr = [], cg = [], cb = [];
      for (Y = A.R.y0; Y < A.R.y1; Y += 3) for (X = A.R.x0; X < A.R.x1; X += 3) {
        i = Y * W + X; if (A.bg[i] || inkT(A, i) >= 0.25) continue;
        cr.push(p[i * 4]); cg.push(p[i * 4 + 1]); cb.push(p[i * 4 + 2]);
      }
      var mid = function (a) { a.sort(function (q, w) { return q - w; }); return a[(a.length / 2) | 0] || 0; };
      var fab = [mid(cr), mid(cg), mid(cb)];
      var clean = function (j) {
        if (A.bg[j] || inkT(A, j) >= 0.25) return false;
        var dr = p[j * 4] - fab[0], dg = p[j * 4 + 1] - fab[1], db = p[j * 4 + 2] - fab[2];
        return dr * dr + dg * dg + db * db <= 50 * 50;
      };
      for (Y = by0; Y <= by1; Y++) {
        var L = -1, Rr = -1, q;
        for (q = bx0 - 1; q >= Math.max(0, bx0 - 40); q--) if (clean(Y * W + q)) { L = Y * W + q; break; }
        for (q = bx1 + 1; q <= Math.min(W - 1, bx1 + 40); q++) if (clean(Y * W + q)) { Rr = Y * W + q; break; }
        if (L < 0 && Rr < 0) continue;
        if (L < 0) L = Rr; if (Rr < 0) Rr = L;
        var lx = L % W, rx = Rr % W;
        for (X = bx0; X <= bx1; X++) {
          i = Y * W + X;
          if (A.bg[i]) continue;
          var f = rx > lx ? Math.min(1, Math.max(0, (X - lx) / (rx - lx))) : 0.5;
          k = i * 4;
          p[k] = p[L * 4] * (1 - f) + p[Rr * 4] * f;
          p[k + 1] = p[L * 4 + 1] * (1 - f) + p[Rr * 4 + 1] * f;
          p[k + 2] = p[L * 4 + 2] * (1 - f) + p[Rr * 4 + 2] * f;
        }
      }
    } else {
      // Garments: rebuild the fabric under the old print (shading + texture).
      var gm = inkMask(A, { x0: bx0, x1: bx1 + 1, y0: by0, y1: by1 + 1 }, 0.1, 4);
      var fill = fabricFill(A, gm.m, bx0, bx1, by0, by1), outF = [];
      for (Y = gm.box.y0; Y <= gm.box.y1; Y++) for (X = gm.box.x0; X <= gm.box.x1; X++) {
        i = Y * W + X;
        if (!gm.m[i] || A.bg[i]) continue;
        // Blend toward rebuilt fabric by how much ink the pixel holds, so the
        // patch has no visible edge.
        var fv = fill(i), kf = Math.max(0, Math.min(1, inkT(A, i) / 0.12)), k1 = i * 4;
        outF.push(i, p[k1] * (1 - kf) + fv[0] * kf, p[k1 + 1] * (1 - kf) + fv[1] * kf, p[k1 + 2] * (1 - kf) + fv[2] * kf);
      }
      for (var q3 = 0; q3 < outF.length; q3 += 4) { k = outF[q3] * 4; p[k] = outF[q3 + 1]; p[k + 1] = outF[q3 + 2]; p[k + 2] = outF[q3 + 3]; }
    }

    // 2. Stamp the new logo, sized like it prints relative to the old one,
    //    centered on the garment where the old logo sat.
    // Caps come in different shapes, so size from the donor's share of the cap.
    var newW = cap ? relNew.rel * A.gw : Math.min(ob.w * (relNew.rel / relOld.rel), A.gw * 0.6);
    var s = newW / db.w, newH = db.h * s;
    // Caps: center on the old logo (the mesh side panel skews the cap's own center).
    var cxNew = cap ? (ob.x0 + ob.x1) / 2 : ob.cx;
    var left = cxNew - newW / 2, top = (ob.y0 + ob.y1) / 2 - newH / 2;
    var tr = parseInt(hex.slice(1, 3), 16), tg = parseInt(hex.slice(3, 5), 16), tb = parseInt(hex.slice(5, 7), 16);
    for (Y = Math.max(0, top | 0); Y < Math.min(H, top + newH); Y++) {
      for (X = Math.max(0, left | 0); X < Math.min(W, left + newW); X++) {
        i = Y * W + X;
        if (A.bg[i]) continue;
        var sx = Math.round(db.x0 + (X - left) / s), sy = Math.round(db.y0 + (Y - top) / s);
        if (sx < 0 || sy < 0 || sx >= D.W || sy >= D.H) continue;
        var si = sy * D.W + sx;
        if (D.bg[si]) continue;
        var m = (inkT(D, si) - 0.45) / 0.35;
        if (m <= 0) continue;
        if (m > 1) m = 1;
        k = i * 4;
        p[k] = p[k] * (1 - m) + tr * m; p[k + 1] = p[k + 1] * (1 - m) + tg * m; p[k + 2] = p[k + 2] * (1 - m) + tb * m;
      }
    }
    A.ctx.putImageData(A.img, 0, 0);
    try { return A.canvas.toDataURL('image/webp', 0.9); } catch (e) { return null; }
  }

  /* cfg: { photos: [[file, color, logo], ...], donors: { logo: file } }
     Returns { url, kind } where kind is 'recolor' (a photo of this logo exists)
     or 'compose' (logo moved onto this garment from another photo), or null. */
  async function preview(cfg, color, logo, hex, regionKey) {
    regionKey = REGIONS[regionKey] ? regionKey : 'garment';
    if (!cfg || !cfg.photos || !/^#[0-9a-fA-F]{6}$/.test(hex)) return null;
    var same = cfg.photos.filter(function (r) { return r[1] === color && r[2] === logo; }).map(function (r) { return r[0]; });
    if (same.length) {
      var u = await render(same, hex, regionKey);
      if (u) return { url: u, kind: 'recolor' };
    }
    var donor = cfg.donors && cfg.donors[logo];
    if (!donor) return null;
    var bases = cfg.photos.filter(function (r) { return r[1] === color && cfg.donors[r[2]]; });
    // No photo of this color with a known logo: use any photo of the color.
    if (!bases.length) bases = cfg.photos.filter(function (r) { return r[1] === color; });
    var scored = [];
    for (var j = 0; j < bases.length; j++) {
      var sp = await spanOf(bases[j][0], regionKey);
      if (sp >= 25) scored.push([sp, bases[j]]);  // erasing needs less contrast than recoloring
    }
    scored.sort(function (x, y) { return y[0] - x[0]; });
    for (var n = 0; n < scored.length; n++) {
      var best = scored[n][1];
      var key = 'c|' + best[0] + '|' + donor + '|' + hex + '|' + regionKey;
      if (outCache[key]) return { url: outCache[key], kind: 'compose' };
      try {
        var url = await compose(best[0], cfg.donors[best[2]] || null, donor, hex, regionKey);
        if (url) { outCache[key] = url; return { url: url, kind: 'compose' }; }
      } catch (e) {}
    }
    return null;
  }

  window.SZRecolor = { render: render, preview: preview, compose: compose, _i: { load: load, analyze: analyze, findLogo: findLogo, inkT: inkT, spanOf: spanOf, REGIONS: REGIONS } };
})();
